import React, { useContext, useEffect, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import Select from "react-select"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
import {
  numberFormat,
  getTodayDateISO,
  selectDropdownStyle,
  dateFormat,
  numberFormatInt,
} from "../../../Helpers/Utils/Common"
import DatePicker from "react-datepicker"
import Moment from "moment"
import { CSVLink } from "react-csv"
import downloadIcon from "../../../Assets/Images/download_icon.png"

import { getAllPurchasedItemsSummary } from "../../../Helpers/apiCalls/Reports/BillingFeeSales"
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi"
import * as XLSX from "xlsx"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function PurchasedItemsSummary() {
  const { setDateFrom, setDateTo, dateFilter } = useContext(Context)
  const [inactive, setInactive] = useState(true)
  const [filterConfig, setFilterConfig] = useState({
    page: 1,
    purchase_date_from: dateFilter.date_from || "",
    purchase_date_to: dateFilter.date_to || "",
  })
  const [showLoader, setShowLoader] = useState(false)
  const [sales, setSales] = useState([])
  const [salesCsv, setSalesCsv] = useState([])
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [items, setItems] = useState([])
  const [excelData, setExcelData] = useState([])
  const xlsxHeaders = [
    "RECEIVED DATE",
    "PURCHASED DATE",
    "INVOICE/DR NO.",
    "ITEM NAME",
    "SUPPLIER/VENDOR",
    "QTY",
    "UNIT",
    "PRICE",
    "AMOUNT",
  ]
  const excelHeaders = [
    { label: "Total Quantity", key: "total_quantity" },
    { label: "Total Amount", key: "total_amount" },
    { label: "Receive Date", key: "receive_date" },
    { label: "Purchase Date", key: "purchase_date" },
    { label: "Invoice/DR No.", key: "dr_no" },
    { label: "Item Name", key: "item_name" },
    { label: "Supplier/Vendor", key: "supplier_name" },
    { label: "Quantity", key: "quantity" },
    { label: "Unit", key: "unit" },
    { label: "Price", key: "price" },
    { label: "Amount", key: "amount" },
  ]
  const [itemOptions, setItemOptions] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target
    if (name === "item_id") {
      var id = value.split("-")[0]
      var shop = value.split("-")[1]
      setFilterConfig((prev) => {
        return {
          ...prev,
          item_id: id,
          type: shop,
        }
      })
    } else {
      setFilterConfig((prev) => {
        return { ...prev, [name]: value }
      })
    }
  }

  function handleSelectChange(e, row) {
    if (e.target.value === "mark_as_done") {
      // handleShowApproveModal();
    } else if (e.target.value === "void") {
      // handleShowDeleteModal();
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
      </Form.Select>
    )
  }

  function PrintBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.po_id}
        onClick={() => handlePrint(row.po_id, row.type)}
      >
        View
      </button>
    )
  }

  function handlePrint(id, type) {
    window.open("purchaseorders/review/1/" + id, "_blank")
  }

  function handleItemChange(e) {
    const toFilter = { target: { name: "item_id", value: e.value } }
    handleOnSearch(toFilter)
  }

  async function fetchData() {
    setShowLoader(true)
    setExcelData([])
    setSales([])
    setTotalQuantity(0)
    setTotalAmount(0)
    setTotalItems(0)
    var total = {
      total_amount: "",
      total_quantity: "",
    }

    const response = await getAllPurchasedItemsSummary(filterConfig)
    console.log(response)
    if (response.data) {
      setTotalItems(response.data.size)
      var allItems = response.data.purchase_items.map((item) => {
        var info = item
        info.type = ""
        info.po_id = item.po_id
        info.receive_date = Moment(item.receive_date).format("MMM DD, YYYY")
        info.purchase_date = Moment(item.purchase_date).format("MMM DD, YYYY")
        info.quantity = numberFormat(item.quantity)
        info.price = numberFormat(item.price)
        info.amount = numberFormat(item.total_amount)
        // info.total_amount = "";
        return info
      })

      var quantity = response.data.summary
        ? response.data.summary.total_quantity
        : "0"
      var amount = response.data.summary
        ? response.data.summary.total_amount
        : "0"
      total["total_amount"] = numberFormat(amount)
      total["total_quantity"] = numberFormat(quantity)
      setTotalQuantity(quantity)
      setTotalAmount(amount)

      setSales(allItems)

      var excel = allItems.map((bill) => {
        var info = {}
        info.receive_date = bill.receive_date
        info.purchase_date = bill.purchase_date
        info.dr_no = bill.dr_no
        info.item_name = bill.item_name
        info.supplier_name = bill.supplier_name
        info.quantity = numberFormatInt(bill.quantity)
        info.unit = bill.unit
        info.price = numberFormatInt(bill.price)
        info.amount = numberFormatInt(bill.amount)
        return info
      })
      setExcelData(excel)
    }

    setShowLoader(false)
  }

  console.log(currentPage, totalItems, itemsPerPage)

  async function fetchAllItems() {
    const response = await getAllItems()
    // const response2 = await getAllItemsPotato();

    if (response.response.data) {
      var data = response.response.data.map((item) => {
        var info = item
        info.id = item.id
        info.label = item.name
        info.value = item.id
        return info
      })
      setItems([{ label: "All items", value: "" }, ...data])
    }
  }

  function handleExport() {
    const rows = excelData
    const header = ["", ""]
    const meta = [
      ["REPORT TITLE:", "SUMMARY OF PURCHASED ITEMS"],
      [
        "ITEM:",
        filterConfig.item_name !== "" && filterConfig.item_name !== undefined
          ? filterConfig.item_name
          : "All Items",
      ],
      [
        "DATE FROM:",
        filterConfig.date_from !== "" && filterConfig.date_from !== undefined
          ? dateFormat(filterConfig.date_from)
          : "N/A",
      ],
      [
        "DATE TO:",
        filterConfig.date_to !== "" && filterConfig.date_to !== undefined
          ? dateFormat(filterConfig.date_to)
          : "N/A",
      ],
      ["QUANTITY:", totalQuantity],
      ["AMOUNT:", totalAmount],
    ]

    const sheet = XLSX.utils.json_to_sheet([{}], {
      header: header,
    })

    /* generate worksheet and workbook */
    const workbook = XLSX.utils.book_new()
    XLSX.utils.sheet_add_json(sheet, rows, { origin: "A8" })
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(sheet, meta, { origin: "A1" })
    XLSX.utils.sheet_add_aoa(sheet, [xlsxHeaders], { origin: "A8" })
    XLSX.writeFile(
      workbook,
      `SummaryOfPurchasedItems (${Moment().format("MMM DD, YYYY")}).xlsx`,
      { compression: true }
    )
  }

  useEffect(() => {
    fetchAllItems()
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"EXPENSES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SUMMARY OF PURCHASED ITEMS{" "}
            </h1>
          </Col>
        </Row>

        <div className="tab-content">
          {/* filters */}
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Item"
                styles={selectDropdownStyle}
                options={items}
                onChange={handleItemChange}
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.purchase_date_from}
                name="purchase_date_from"
                placeholderText={"Select Date"}
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    return { ...prev, purchase_date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                dateFormat={"MMM dd, yyyy"}
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.purchase_date_to}
                name="purchase_date_to"
                placeholderText={"Select Date"}
                onChange={(date) => {
                  setDateTo(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, purchase_date_to: date }
                  })
                }}
                fixedHeight
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                dateFormat={"MMM dd, yyyy"}
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-2" />

          <div className="my-2 px-2 PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              Quantity: {numberFormat(totalQuantity)}
            </span>

            <span className="me-4 ml-8 align-middle mt-2 ps-label">
              Amount: {numberFormat(totalAmount)}
            </span>
          </div>

          <div className="below">
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "RECEIVED DATE",
                "PURCHASED DATE",
                "INVOICE/DR NO.",
                "ITEM NAME",
                "SUPPLIER/VENDOR",
                "QTY",
                "UNIT",
                "PRICE",
                "AMOUNT",
              ]}
              headerSelector={[
                "-",
                "receive_date",
                "purchase_date",
                "dr_no",
                "item_name",
                "supplier_name",
                "quantity",
                "unit",
                "price",
                "amount",
              ]}
              tableData={sales}
              ActionBtn={(row) => ActionBtn(row, "open")}
              ViewBtn={(row) => PrintBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div className="mb-2" />
        </div>
        <div className="mb-3" />
        <br />
        <br />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <Footer />
    </div>
  )
}
